import { render, staticRenderFns } from "./addIncome.vue?vue&type=template&id=e23908a2&scoped=true&"
import script from "./addIncome.vue?vue&type=script&lang=js&"
export * from "./addIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23908a2",
  null
  
)

export default component.exports